
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class NavThemeController extends Controller {

	/**
	* I determine if this controller should load for the current client.
	*/
	static get shouldLoad() {

		return( window.localStorage && window.matchMedia );

	}

	// ---
	// LIFE-CYCLE METHODS.
	// ---

	/**
	* I get called whenever this instance is bound to a host element.
	*/
	connect() {

		this.prefersDark = window.matchMedia( "( prefers-color-scheme: dark )" )
			.matches
		;
		this.prefersLight = ! this.prefersDark;

	}

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I set the theme associated with the target button.
	*/
	setTheme( event ) {

		var theme = event.target.dataset.theme;

		document.documentElement
			.setAttribute( "data-theme", theme )
		;

		// When the user toggles the theme, we want to, if possible, UNSET the persisted
		// value so that we can keep the theme in alignment with the system preferences.
		// So, if the user is toggling the theme back to one that matches the current
		// system preferences, then we want REMOVE the storage item so that any system-
		// level changes will be reflected implicitly in the future.
		// --
		// CAUTION: Some browsers throw an error when accessing the local storage API even
		// when it exists.
		try {

			if (
				( ( theme === "light" ) && this.prefersLight ) ||
				( ( theme === "dark" ) && this.prefersDark )
				) {

				localStorage.removeItem( "theme" );

			} else {

				localStorage.setItem( "theme", theme );

			}

		} catch ( error ) {

			console.warn( "Local storage access error", error );

		}

	}

}
